export default __webpack_public_path__ + "static/sametova-revoluce-92b5a60d70689bcd29523e3ac18cbfa7.avif";